import { rem } from "@mantine/core";
import { type DiscoverPromoSlide } from "./components/DiscoverPromoCarousel";

export const DEFAULT_PAGE_SIZE = 10;
export const DISCOVER_PAGE_SIZE_OPTIONS = [10, 20, 50] as const;

export const DISCOVER_TYPEWRITER_PHRASES = [
  "Manufacturer in Southeast Asia",
  "Distributor in Middle East",
  "OEM Supplier in India",
  "Contract Manufacturer Asia",
] as const;

export const LOADER_SHOW_DELAY_MS = 150;
export const LOADER_MIN_VISIBLE_MS = 320;

/** Delay before `quickSearch` / browse+AI fetch runs while the user types in the keyword field. */
export const QUICK_SEARCH_DEBOUNCE_MS = 700;

/** Space under scrollable content so the last cards clear the fixed mobile promo strip. */
export const MOBILE_PROMO_STRIP_RESERVE = rem(200);

/** Approx. mobile strip height (paper vertical padding + carousel) for dock sentinel math. */
export const MOBILE_PROMO_STRIP_PX = 150;

export const MAX_RETRIES = 2;

export const DEFAULT_DISCOVER_PROMO_SLIDES: DiscoverPromoSlide[] = [
  {
    id: "promo-collab-india-china",
    flags: ["IN", "CN"],
    headline: "Recent collaboration",
    description: "Indian and Chinese collaboration made!",
  },
  {
    id: "promo-collab-poland-vietnam",
    flags: ["PL", "VN"],
    headline: "Recent collaboration",
    description: "Poland and Vietnamese collaboration made!",
  },
  {
    id: "promo-collab-turkey-united-states",
    flags: ["TR", "US"],
    headline: "Recent collaboration",
    description: "Turkish and United States collaboration made!",
  },
];
